import { render, staticRenderFns } from "./ExpenseOrderDetail.vue?vue&type=template&id=1c72695f&scoped=true&"
import script from "./ExpenseOrderDetail.vue?vue&type=script&lang=js&"
export * from "./ExpenseOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseOrderDetail.vue?vue&type=style&index=0&id=1c72695f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c72695f",
  null
  
)

component.options.__file = "ExpenseOrderDetail.vue"
export default component.exports